module.exports = __webpack_public_path__ + "static/img/group_qr_code2.bb4514c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group_qr_code2.png
// module id = O/i8
// module chunks = 1